/* eslint-disable */
/**
 * SessionValidator — checks if user is authenticated via httpOnly cookie
 * Used for cross-subdomain SSO between admin.saludti.es and web.saludti.es
 */

import * as url from "Helper/UrlHelper";
import { getData } from "utils/Gateway";

/**
 * Validates session using httpOnly cookie.
 * If valid, updates localStorage with user data.
 * Returns: { isValid: boolean, userData: object | null }
 */
export const validateSession = async () => {
  try {
    const requestURL = url.API_BASE_URL + url.API_AUTH_VALIDATE;

    // This call uses the cookie automatically (httpOnly)
    // No need to pass token since it's sent via cookie
    const response = await getData(requestURL);

    // Check nested status - response.status is HTTP success, response.data.status is auth success
    if (response.status && response.data && response.data.status === true) {
      // Valid session found! Update localStorage so the app recognizes the user
      localStorage.setItem("userInfo", JSON.stringify(response.data.data));
      localStorage.setItem("userID", JSON.stringify(response.data.data._id));
      localStorage.setItem("token", "authenticated"); // Marker for isLoggedIn check
      localStorage.setItem("ecosystem", response.data.ecosystemid);
      localStorage.setItem("ecosystemslug", response.data.ecosystemslug);
      localStorage.setItem("ecosystemlogo", response.data.ecosystemlogo || "");

      if (response.data.data.language) {
        localStorage.setItem("userLanguage", response.data.data.language);
      }

      return { isValid: true, userData: response.data.data };
    }

    // No valid session - clear any stale localStorage data
    clearSession();
    return { isValid: false, userData: null };
  } catch (error) {
    console.error("Session validation error:", error);
    // Clear stale data on error too
    clearSession();
    return { isValid: false, userData: null };
  }
};

/**
 * Clears all session data from localStorage
 */
export const clearSession = () => {
  const keysToRemove = [
    "userInfo",
    "userID",
    "token",
    "ecosystem",
    "ecosystemslug",
    "ecosystemlogo",
    "userLanguage",
    "moduleaccess"
  ];
  
  keysToRemove.forEach(key => localStorage.removeItem(key));
};
